module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/auction-consultancy-small.0461506334f199b8c7f2500cef14130a.jpg";